import { useTranslation } from "react-i18next";
import "../spf.scss";
import "./spf-profile.scss";
import { useNavigate } from "react-router-dom";
import { DeleteOutlined, EditOutlined, HomeOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Col, Form, Image, Input, Row, Select, Steps, Tooltip } from "antd";
import { Content } from "antd/es/layout/layout";
import { _adr } from "../../../../address";
import { convertPersian, delay, exportNormalFile, fileToformData, isEmpty, urltoFile, validateInput } from "../../../../tools/tools";
import { useEffect, useState } from "react";
import DatePicker from "../../../auxiliary/datepicker/datepicker";
import { useAPIPublic, useDealer } from "../../../../tools/api";
import UploadImages from "../../../auxiliary/uploadImages/upload";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../auxiliary/loader/loading";
import { simcardPurchase } from "../../../../reducer/serviceReducer";
import SPFShopLayout from "../spf-shop-layout";
import ResizeImage from "../../../auxiliary/resizeImg/resizeImage";
const SPFProfile = () => {
	const [t] = useTranslation("global");
	const nav = useNavigate();
	const [frmProfile] = Form.useForm();

	//#region Hook Call API
	const { queryProfileByCertNoVBirthDate, addressByPostcode, addProfile, addAddress } = useDealer();
	const {
		queryCertType,
		queryGender,
		queryActiveCountry,
		queryActiveLanguage,
		queryActiveProvince,
		queryActiveCityByProvinceId,
		addDocument,
		queryCityByCityId,
	} = useAPIPublic();
	//#endregion Hook Call API

	/// reducer
	const formData = useSelector((state) => state?.from?.spForeign);
	const dispatch = useDispatch();
	/// reducer

	console.log(formData);

	//Loading Control Page
	const [isLoading, setIsLoading] = useState(false);
	//Loading Control Page

	//#region initialForm Set Data
	const [initialFrom, setInitialFrom] = useState({
		gender: [],
		certType: [],
		country: [],
		language: [],
		province: [],
		city: [],
	});

	useEffect(() => {
		const callInitialService = async () => {
			//call Services CertType
			let resCert = await queryCertType();
			if (resCert) {
				setInitialFrom((prev) => ({ ...prev, certType: resCert }));
			}
			//Call Service Gender
			let resGender = await queryGender();
			if (resGender) {
				setInitialFrom((prev) => ({ ...prev, gender: resGender }));
			}

			//cal service Country
			let resCountry = await queryActiveCountry();
			if (resCountry) {
				resCountry.sort((a, b) => {
					if (a.inT_OrderId < b.inT_OrderId) return -1;
					if (a.inT_OrderId > b.inT_OrderId) return 1;
					return 0;
				});
				setInitialFrom((prev) => ({ ...prev, country: resCountry }));
			}
			//cal service Language
			let reslang = await queryActiveLanguage();
			if (reslang) {
				setInitialFrom((prev) => ({ ...prev, language: reslang }));
			}
			//cal service Province
			let resProvince = await queryActiveProvince();
			if (resProvince) {
				setInitialFrom((prev) => ({ ...prev, province: resProvince }));
			}
		};
		callInitialService();
	}, []);

	// Call Service Get ALL City By Province ID
	const handleCityListByProvinceId = async (item) => {
		let resCity = await queryActiveCityByProvinceId(item);
		if (resCity) {
			setInitialFrom((prev) => ({ ...prev, city: resCity }));
		}
	};
	//#endregion initialForm Set Data

	//#region Check Call API Profile And Post

	const [b_birtday, setb_birtday] = useState("");
	const [b_certno, setb_certno] = useState("");
	const [p_birtday, setp_birtday] = useState("");
	const [p_certno, setp_certno] = useState("");

	const [postalCode, setPostalCode] = useState("");
	const [prevPostalCode, setPrevPostalCode] = useState("");

	useEffect(() => {
		const handleReadProfile = async () => {
			if (b_certno?.length > 0 && b_birtday?.length > 0) {
				if (b_birtday !== p_birtday || b_certno !== p_certno) {
					let payload = {
						certno: frmProfile.getFieldValue("certno"),
						birthdate: frmProfile.getFieldValue("birthdate"),
					};
					let response = await queryProfileByCertNoVBirthDate(payload);
					if (response) {
						setp_birtday(b_birtday);
						setp_certno(b_certno);
						frmProfile.setFieldsValue({
							fname: response?.fname,
							lname: response?.lname,
							fathername: response?.fathername,
							gender: response?.gender,
							countryid: response?.countryid,
							languageid: response?.languageid,
							email: response?.email,
						});
						if (response?.address?.postalcode?.length > 0) {
							frmProfile.setFieldValue("postalcode", response?.address?.postalcode);
							setPostalCode(response?.address?.postalcode);
						}
					}
				}
			}
		};
		const CallPostalCode = async () => {
			if (postalCode.length > 0 && postalCode !== prevPostalCode) {
				let payload = {
					postCode: frmProfile.getFieldValue("postalcode"),
				};
				let resPost = await addressByPostcode(payload);
				if (resPost) {
					setPrevPostalCode(postalCode);
					frmProfile.setFieldsValue({
						mainstreet: resPost?.mainStreet,
						buildingno: resPost?.buildingNo,
						floor: resPost?.floor,
						alley: resPost?.alley,
						auxiliaryroad: resPost?.auxiliaryRoad,
						tel: resPost?.tel,
					});
					if (resPost?.cityId) {
						let resProvince = await queryCityByCityId(resPost?.cityId);
						if (resProvince) {
							frmProfile.setFieldsValue({
								provinceid: resProvince?.provinceid,
							});
							handleCityListByProvinceId(resProvince?.provinceid);
						}
					}
				}
			}
		};
		handleReadProfile();
		CallPostalCode();
	}, [b_certno, b_birtday, postalCode]);
	//#endregion Check Call API Profile And Post

	//#region set Data From reducer
	useEffect(() => {
		// frmProfile.setFieldValue("certtype", formData?.certtype);
		if (formData?.profile) {
			handleCityListByProvinceId(formData?.profile?.provinceid);
			frmProfile.setFieldsValue({
				certno: formData?.profile?.certno,
				birthdate: formData?.profile?.birthdate,
				fname: formData?.profile?.fname,
				lname: formData?.profile?.lname,
				fathername: formData?.profile?.fathername,
				gender: formData?.profile?.gender,
				countryid: formData?.profile?.countryid,
				languageid: formData?.profile?.languageid,
				email: formData?.profile?.email,
				photo: formData?.profile?.photo,
				postalcode: formData?.profile?.postalcode,
				provinceid: formData?.profile?.provinceid,
				cityid: formData?.profile?.cityid,
				tel: formData?.profile?.tel,
				mainstreet: formData?.profile?.mainstreet,
				alley: formData?.profile?.alley,
				auxiliaryroad: formData?.profile?.auxiliaryroad,
				buildingno: formData?.profile?.buildingno,
				floor: formData?.profile?.floor,
				unit: formData?.profile?.unit,
			});
			// setUpFile();
		}
		setb_certno(formData?.certno);
		frmProfile.setFieldValue("certno", formData?.certno);
		if (formData?.documenttype === "Passport") {
			setIsLangPersian(false);
		}
	}, [formData]);
	//#endregion set Data From reducer

	//#region Date Picker Provider
	const [isLangPersian, setIsLangPersian] = useState(true);
	const handleGetDate = (temp) => {
		frmProfile.setFieldValue("birthdate", temp);
		setb_birtday(temp);
	};
	//#endregion Data Picker Provider

	const handleSubmit = async () => {
		setIsLoading(true);
		try {
			let valid = await frmProfile.validateFields();
			if (valid) {
				let resDoc = await addDocument(await fileToformData(valid.photo), formData?.documenttype);
				if (resDoc) {
					let payload = {
						fname: valid.fname,
						lname: valid.lname,
						fathername: isEmpty(valid.fathername) ? "پدر" : valid.fathername,
						identityno: 0,
						certno: valid.certno,
						certtype: formData?.certtype,
						birthdate: valid.birthdate.replace(/\//g, "-"),
						gender: valid.gender,
						smsmobileno: formData?.smsmobileno?.toString()?.slice(0) || "",
						email: valid.email,
						documentid: resDoc.Result,
						profiletype: 23,
						languageid: valid.languageid,
						countryid: valid.countryid,
						nationality: "",
						spbundleinfo: {
							sppurchasebundleid: formData?.spbundle?.bundleSalesSimId,
						},
					};
					let resProfile = await addProfile(payload);
					if (resProfile) {
						payload = {
							profileid: resProfile.profileId,
							addresstype: 0,
							addressmodel: {
								cityid: valid.cityid,
								mainstreet: valid.mainstreet,
								auxiliaryroad: valid.auxiliaryroad,
								alley: valid.alley,
								buildingno: valid.buildingno,
								floor: valid.floor,
								postalcode: valid.postalcode,
								tel: valid.tel,
								unit: valid.unit,
							},
						};
						let resAddress = await addAddress(payload);
						if (resAddress && !resAddress.HasError) {
							payload.addresstype = 1;
							let resAgainAddress = await addAddress(payload);
							if (resAgainAddress && !resAgainAddress.HasError) {
								let txtGender = initialFrom?.gender.find((item) => item.value === valid.gender)?.name;
								let txtProvince = initialFrom?.province.find((item) => item.inT__ProvinceId === valid.provinceid)?.stR_ProvinceName;
								let txtCity = initialFrom?.city.find((item) => item.inT_CityId === valid.cityid)?.stR_CityName;
								let txtLanguage = initialFrom?.language.find((item) => item.inT_LanguageId === valid.languageid)?.stR_Language;
								let txtCountry = initialFrom?.country.find((item) => item.inT_CountryId === valid.countryid)?.stR_CountryName;

								dispatch(
									simcardPurchase({
										spForeign: {
											...formData,
											profile: {
												...valid,
												txtGender: txtGender,
												txtProvince: txtProvince,
												txtCity: txtCity,
												txtLanguage: txtLanguage,
												txtCountry: txtCountry,
											},
										},
									}),
								);
								nav(_adr.Root + _adr.SimCardPurchase.foreigners + _adr.SimCardPurchase.foreignersChild.PreFactor);
							}
						}
					}
				}
			}
			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
		}
	};

	const handleGetImage = async (value) => {
		frmProfile.setFieldValue("photo", value);
	};

	return (
		<>
			<SPFShopLayout>
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("simcardpurchase.foreigners.title") }]}
					/>
					<div className="title-page">
						<h3>{t("simcardpurchase.foreigners.title")}</h3>
						<p></p>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main sp-container">
						<div className="g-format-page">
							<div className="g-body-format-page">
								<div className="g-format-steps">
									<div className="holder-step">
										<Steps
											size="small"
											className="step-wizard"
											current={2}
											items={[
												{
													title: "بسته آغازین",
												},
												{
													title: "احراز هویت",
												},
												{
													title: "اطلاعات هویتی",
												},
												{
													title: "پیش فاکتور",
												},
												{
													title: "سند",
												},
											]}
										/>
									</div>
								</div>
								<div className="holder-form-group">
									<div className="holder-title-form">
										<h3>اطلاعات هویتی </h3>
										<div className="holder-form">
											<Form form={frmProfile} name="frmProfile" layout="vertical" autoComplete="off">
												<Row gutter={30}>
													<Col xs={24} sm={12} md={12} lg={10} xl={8}>
														<Form.Item
															className="input-normal"
															name="certno"
															rules={[
																validateInput({
																	t: t,
																	validate: true,
																	type: "number",
																}),
															]}
															label="شماره مدرک شناسایی">
															<Input
																dir="ltr"
																disabled
																inputMode="numeric"
																autoComplete="off"
																onChange={(e) => {
																	e.target.value = convertPersian(e.target.value);
																	setb_certno(e.target.value);
																}}
															/>
														</Form.Item>
													</Col>
													<Col xs={24} sm={12} md={12} lg={10} xl={8}>
														<Form.Item className="input-normal" name="birthdate" rules={[validateInput({ t: t, validate: true })]} label="تاریخ تولد">
															<DatePicker values={frmProfile.getFieldValue("birthdate")} onChange={handleGetDate} lang={isLangPersian} />
														</Form.Item>
													</Col>
												</Row>
												<Row gutter={30}>
													<Col xs={24} sm={12} md={12} lg={10} xl={8}>
														<Form.Item
															className="input-normal"
															name="fname"
															label="نام"
															rules={[
																validateInput({
																	t: t,
																	validate: true,
																	type: isLangPersian ? "persian" : "english",
																}),
															]}>
															<Input dir={isLangPersian ? "rtl" : "ltr"} onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
														</Form.Item>
													</Col>
													<Col xs={24} sm={12} md={12} lg={10} xl={8}>
														<Form.Item
															className="input-normal"
															name="lname"
															label="نام خانوادگی"
															rules={[
																validateInput({
																	t: t,
																	validate: true,
																	type: isLangPersian ? "persian" : "english",
																}),
															]}>
															<Input dir={isLangPersian ? "rtl" : "ltr"} onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
														</Form.Item>
													</Col>
												</Row>
												<Row gutter={30}>
													<Col xs={24} sm={12} md={12} lg={10} xl={8}>
														<Form.Item
															className="input-normal"
															name="fathername"
															label="نام پدر"
															rules={[
																validateInput({
																	t: t,
																	validate: isLangPersian ? true : false,
																	type: isLangPersian ? "persian" : "",
																}),
															]}>
															<Input dir={isLangPersian ? "rtl" : "ltr"} onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
														</Form.Item>
													</Col>
													<Col xs={24} sm={12} md={12} lg={10} xl={8}>
														<Form.Item className="input-normal" name="gender" label="جنسیت" rules={[validateInput({ t: t, validate: true })]}>
															<Select>
																{initialFrom?.gender.map((item, key) => (
																	<Select.Option key={key} value={item.value}>
																		{item.name}
																	</Select.Option>
																))}
															</Select>
														</Form.Item>
													</Col>
												</Row>
												<Row gutter={30}>
													<Col xs={24} sm={12} md={12} lg={10} xl={8}>
														<Form.Item className="input-normal" name="countryid" label="کشور" rules={[validateInput({ t: t, validate: true })]}>
															<Select showSearch filterOption={(inputValue, option) => option.children.toString().startsWith(inputValue)}>
																{initialFrom?.country.map((item, key) => (
																	<Select.Option key={key} value={item.inT_CountryId}>
																		{item.stR_CountryName}
																	</Select.Option>
																))}
															</Select>
														</Form.Item>
													</Col>
													<Col xs={24} sm={12} md={12} lg={10} xl={8}>
														<Form.Item className="input-normal" name="languageid" label="زبان" rules={[validateInput({ t: t, validate: true })]}>
															<Select showSearch filterOption={(inputValue, option) => option.children.toString().startsWith(inputValue)}>
																{initialFrom?.language.map((item, key) => (
																	<Select.Option key={key} value={item.inT_LanguageId}>
																		{item.stR_Language}
																	</Select.Option>
																))}
															</Select>
														</Form.Item>
													</Col>
												</Row>
												<Row gutter={30}>
													<Col xs={24} sm={12} md={12} lg={10} xl={8}>
														<Form.Item
															className="input-normal"
															name="email"
															label="پست الکترونیکی"
															rules={[
																validateInput({
																	t: t,
																	validate: false,
																	type: "email",
																}),
															]}>
															<Input dir="ltr" inputMode="email" onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
														</Form.Item>
													</Col>
													<Col xs={24} sm={12} md={12} lg={10} xl={8}></Col>
												</Row>
												<Row gutter={30}>
													<Col xs={24} sm={12} md={24} lg={12} xl={10}>
														<Form.Item className="input-normal" name="photo" rules={[validateInput({ t: t, validate: true })]} label="تصویر مدرک">
															<ResizeImage exportImage={handleGetImage} />
														</Form.Item>
													</Col>
													{/* <Col span={9} style={{ margin: "auto 0" }}>
                            <ul style={{ display: "none" }}>
                              <li>
                                بارگذاری کارت ملی جدید یا شناسنامه جدید یا کارت
                                ملی قدیمی همراه با رسید کارت ملی جدید
                              </li>
                              <li>فرمت ها و حجم و رزولوشن قابل قبول</li>
                              <li>
                                توضیح در مورد مشخص بودن گوشه های تصویر مدارک
                              </li>
                            </ul>
                          </Col> */}
												</Row>
												<h3>اطلاعات آدرس </h3>
												<Row gutter={30}>
													<Col xs={24} sm={12} md={12} lg={10} xl={8}>
														<Form.Item
															className="input-normal"
															name="postalcode"
															label="کدپستی"
															rules={[
																validateInput({
																	t: t,
																	validate: true,
																	type: "number",
																	length: 10,
																}),
															]}>
															<Input
																onBlur={(item) => {
																	setPostalCode(item.target.value);
																}}
																onChange={(e) => (e.target.value = convertPersian(e.target.value))}
																dir="ltr"
																maxLength={10}
																inputMode="numeric"
																placeholder="کدپستی خود را وارد کنید"
															/>
														</Form.Item>
													</Col>
													<Col xs={24} sm={12} md={12} lg={10} xl={8}>
														<Form.Item className="input-normal" name="provinceid" label="استان" rules={[validateInput({ t: t, validate: true })]}>
															<Select
																filterOption={(inputValue, option) => {
																	return option.children.toString().startsWith(inputValue.toString());
																}}
																onChange={(item, option) => {
																	handleCityListByProvinceId(item);
																}}
																showSearch>
																{initialFrom?.province.map((item) => (
																	<Select.Option key={item.inT__ProvinceId} value={item.inT__ProvinceId}>
																		{item.stR_ProvinceName}
																	</Select.Option>
																))}
															</Select>
														</Form.Item>
													</Col>
												</Row>
												<Row gutter={30}>
													<Col xs={24} sm={12} md={12} lg={10} xl={8}>
														<Form.Item className="input-normal" name="cityid" label="شهر" rules={[validateInput({ t: t, validate: true })]}>
															<Select
																filterOption={(inputValue, option) => {
																	return option.children.toString().startsWith(inputValue.toString());
																}}
																showSearch>
																{initialFrom?.city.map((item, key) => (
																	<Select.Option key={key} value={item.inT_CityId}>
																		{item.stR_CityName}
																	</Select.Option>
																))}
															</Select>
														</Form.Item>
													</Col>
													<Col xs={24} sm={12} md={12} lg={10} xl={8}>
														<Form.Item
															className="input-normal"
															name="tel"
															label="تلفن"
															rules={[
																validateInput({
																	t: t,
																	validate: true,
																	type: "number",
																}),
															]}>
															<Input
																placeholder="تلفن"
																inputMode="numeric"
																dir="ltr"
																onChange={(e) => (e.target.value = convertPersian(e.target.value))}
															/>
														</Form.Item>
													</Col>
												</Row>
												<Row gutter={30}>
													<Col xs={24} sm={12} md={12} lg={10} xl={8}>
														<Form.Item
															className="input-normal"
															name="mainstreet"
															label="خیابان اصلی"
															rules={[
																validateInput({
																	t: t,
																	validate: true,
																	type: "persian",
																}),
															]}>
															<Input placeholder="خیابان اصلی" onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
														</Form.Item>
													</Col>
													<Col xs={24} sm={12} md={12} lg={10} xl={8}>
														<Form.Item
															className="input-normal"
															name="alley"
															label="کوچه"
															rules={[
																validateInput({
																	t: t,
																	validate: true,
																	type: "persian",
																}),
															]}>
															<Input placeholder="کوچه" onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
														</Form.Item>
													</Col>
												</Row>
												<Row gutter={30}>
													<Col xs={24} sm={12} md={12} lg={10} xl={8}>
														<Form.Item
															className="input-normal"
															name="auxiliaryroad"
															label="خیابان فرعی"
															rules={[
																validateInput({
																	t: t,
																	validate: true,
																	type: "persian",
																}),
															]}>
															<Input placeholder="خیابان فرعی" onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
														</Form.Item>
													</Col>
													<Col xs={24} sm={12} md={12} lg={10} xl={8}>
														<Form.Item
															className="input-normal"
															name="buildingno"
															label="پلاک"
															rules={[
																validateInput({
																	t: t,
																	validate: true,
																	type: "number",
																}),
															]}>
															<Input placeholder="پلاک" inputMode="numeric" onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
														</Form.Item>
													</Col>
												</Row>
												<Row gutter={30}>
													<Col xs={24} sm={12} md={12} lg={10} xl={8}>
														<Form.Item className="input-normal" name="floor" label="طبقه" rules={[validateInput({ t: t, validate: true })]}>
															<Input placeholder="طبقه" onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
														</Form.Item>
													</Col>
													<Col xs={24} sm={12} md={12} lg={10} xl={8}>
														<Form.Item
															className="input-normal"
															name="unit"
															label="واحد"
															rules={[
																{
																	required: true,
																	message: t("validation.required"),
																},
															]}>
															<Input placeholder="واحد" onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
														</Form.Item>
													</Col>
												</Row>
											</Form>
										</div>
									</div>
								</div>
							</div>
							<div className="g-footer-format-page">
								<div className="holder-button">
									<Button className="btn-normal btn-aptel" type="primary" danger onClick={handleSubmit}>
										مرحله بعد
									</Button>
									<Button
										className="btn-normal"
										type="default"
										onClick={() => {
											nav(_adr.Root + _adr.SimCardPurchase.foreigners + _adr.SimCardPurchase.foreignersChild.Authentication);
										}}>
										بازگشت
									</Button>
								</div>
							</div>
						</div>
					</Content>
				</div>
			</SPFShopLayout>

			<Loading isOpen={isLoading} />
		</>
	);
};

export default SPFProfile;
